import { render, staticRenderFns } from "./EntityLink.vue?vue&type=template&id=b44dc286&"
import script from "./EntityLink.vue?vue&type=script&lang=ts&"
export * from "./EntityLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports